import { Link } from "react-router-dom";
import { ArrowRight, BedDouble, MapPin } from "lucide-react";

const fmt = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

function VacancyBadge({ vacant }) {
  const cls = vacant ? "bg-green-100 text-green-800 border-green-300" : "bg-red-50 text-red-800 border-red-200";
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide px-2.5 py-0.5 rounded-full border ${cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${vacant ? "bg-green-600" : "bg-red-600"}`} /> {vacant ? "Vacant" : "Occupied"}
    </span>
  );
}

function RoomRow({ room, propertyName }) {
  return (
    <div className="px-4 py-3 border-b border-slate-100 last:border-0" data-testid={`room-${propertyName}-${room.room_number}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <BedDouble className="h-4 w-4 text-slate-400 shrink-0" />
          <span className="font-semibold text-slate-900 whitespace-nowrap">Room {room.room_number}</span>
        </div>
        <VacancyBadge vacant={room.vacant} />
      </div>
      <div className="mt-2 flex items-center justify-between gap-2">
        <div>
          <span className="font-mono font-bold text-slate-900 tracking-tight">{fmt(room.rent)}<span className="text-xs text-slate-400 font-normal">/mo</span></span>
          <span className="text-[11px] text-slate-400 font-mono ml-2">Dep {fmt(room.deposit)}</span>
        </div>
        {room.vacant ? (
          <Link to="/register" data-testid={`apply-${propertyName}-${room.room_number}`}
                className="bg-blue-600 text-white font-medium py-2 px-4 rounded-md hover:bg-blue-700 transition-colors text-sm inline-flex items-center gap-1.5">
            Apply <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        ) : (
          <span className="bg-slate-100 text-slate-400 font-medium py-2 px-4 rounded-md text-sm cursor-not-allowed select-none">Filled</span>
        )}
      </div>
    </div>
  );
}

export function PropertyCard({ prop }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col"
         data-testid={`property-card-${prop.name}`}>
      <div className="p-5 border-b border-slate-100">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-xl font-semibold tracking-tight text-slate-900">{prop.name}</h3>
            {prop.address && (
              <div className="text-sm text-slate-500 mt-1 inline-flex items-center gap-1.5">
                <MapPin className="h-3.5 w-3.5" /> {prop.address}
              </div>
            )}
          </div>
          <span className="text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap bg-green-100 text-green-800"
                data-testid={`vacancy-count-${prop.name}`}>
            {prop.rooms.length} vacant
          </span>
        </div>
      </div>
      <div className="flex-1 divide-y divide-slate-100">
        {prop.rooms.map((r) => <RoomRow key={r.room_number} room={r} propertyName={prop.name} />)}
      </div>
    </div>
  );
}
